export enum WorkerDocumentType {
  Diploma = 'Diploma',
  Resume = 'Resume',
  Other = 'Other',
}

export interface WorkerDocument {
  id: number
  idWorker?: number
  type: WorkerDocumentType
  url: string
  isApproved?: boolean
  cloudinaryPublicId?: string
  filename: string
}

export type WorkerNotificationPreferences = {
  genericShiftCreation: { email: boolean; push: boolean }
  detailedShiftCreation: { email: boolean; push: boolean }
  poolOfferCreationDetailed: { email: boolean; push: boolean }
}
